const minutesToTime = (minutes) => {
  let mm = minutes % 60;
  let hh = Math.trunc(minutes / 60) % 24;
  if (hh < 10) {
    hh = '0' + hh;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }
  // This formats your string to HH:MM:SS
  let time = hh + ':' + mm + ':00';
  return time;
};

const minutesToHour = (minutes) => {
  let mm = minutes % 60;
  let hh = Math.trunc(minutes / 60) % 24;
  if (hh < 10) {
    hh = '0' + hh;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }
  // This formats your string to HH:MM
  let time = hh + ':' + mm;
  return time;
};

const secondsToTime = (seconds) => {
  let ss = seconds % 60;
  let mm = Math.trunc(seconds / 60);
  if (ss < 10) {
    ss = '0' + ss;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }
  // This formats your string to HH:MM:SS
  let time = mm + ':' + ss;
  return time;
};

export { minutesToTime, minutesToHour, secondsToTime };
